/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const StarHollow: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M14.9593 8.2065L15.1919 8.67774L15.712 8.75342L22.328 9.71624L17.5404 14.3773L17.1634 14.7444L17.2524 15.2629L18.3828 21.8534L12.4648 18.7464L11.9998 18.5023L11.5349 18.7466L5.61598 21.8564L6.74655 15.269L6.83556 14.7504L6.45854 14.3833L1.67071 9.72203L8.28767 8.75432L8.80723 8.67834L9.03966 8.2075L11.9997 2.21125L14.9593 8.2065ZM18.684 22.0116L18.6838 22.0114L18.684 22.0116Z'
      stroke='currentColor'
      fill='transparent'
      strokeWidth='2'
    />
  </React.Fragment>
)
